<template>

  <div v-show="hasAddPermission()" class="col">
    <slot />
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "AppAddButton",
  props: ['permission'],
  components: {
  },
  methods: {
    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/App/AppAddButton.vue